import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import Pharmacytabs from "../Components/Pharmacytabs";
import { imgpharmacy } from "../Constant/Index";
import { useSelector } from "react-redux";
import {
  getPharmacyappointmentsapi,
  getPharmacystaustupdatesapi,
} from "../network/Network";
import Norecord from "../Components/Norecord";
import Swal from "sweetalert2";

const PrescriptionOrdersall = () => {
  const token = useSelector((state) => state?.Auth?.token);
  const [clickedButton, setClickedButton] = useState("pending");
  const [getappoint, setGetappoint] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState("");
  const [isStatusUpdated, setIsStatusUpdated] = useState(false);
  const [selectedId, setSelectedID] = useState("");

  const ttt = selectedOptions;
  const handleSelect = (status, orderId) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      status: status,
      id: orderId,
    }));
  };
  //   =================
  // Button Handler
  const handleClick = (buttonName) => {
    setClickedButton(buttonName);
  };
  //   ================

  // Get Appointment Api
  useEffect(() => {
    getPharmacyappointmentsapi(clickedButton, token).then((res) => {
      setGetappoint(res?.data);
    });
  }, [clickedButton, selectedOptions]);
  
  // ===============
  useEffect(() => {
    if (isStatusUpdated) {
      getPharmacyappointmentsapi(clickedButton, token).then((res) => {
        setGetappoint(res?.data);
      });
    } else {
      getPharmacyappointmentsapi(clickedButton, token).then((res) => {
        setGetappoint(res?.data);
      });
    }
  }, [isStatusUpdated ? isStatusUpdated : clickedButton, selectedOptions]);

  //   Get Status Updated
  useEffect(() => {
    getPharmacystaustupdatesapi(
      selectedOptions?.id,
      selectedOptions?.status,
      token
    )
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Status has been updated",
          showConfirmButton: false,
          timer: 1500,
        });
        setIsStatusUpdated(true);
      })
      .catch((err) => {});
  }, [selectedOptions]);
  //   =================
  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PharmacyProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content  radius-20 p-4">
                <div className="right-side-element">
                  <div className="row pe-3">
                    <div className="col-lg-7">
                      <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                        <div className="edit-btn back">
                          <div className="nav-anchor">
                            {/* <i className="fa-solid fa-arrow-left"></i> */}
                          </div>
                        </div>
                        <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                          Prescription Orders
                        </h5>
                      </div>
                      <ul className="all-tabs">
                        <li className="d-flex align-items-center gap-3">
                          <Link
                            className={
                              clickedButton == "pending"
                                ? "active_btn"
                                : "black-pending"
                            }
                            onClick={() => handleClick("pending")}
                          >
                            Pending
                          </Link>
                          <Link
                            className={
                              clickedButton == "in-progress"
                                ? "active_btn"
                                : "black-progress"
                            }
                            onClick={() => handleClick("in-progress")}
                          >
                            In Progress
                          </Link>
                          <Link
                            className={
                              clickedButton == "completed"
                                ? "active_btn"
                                : "black-complete border-colorful"
                            }
                            onClick={() => handleClick("completed")}
                          >
                            Completed
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-5">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="main-order-wrapper">
                            <h4>{getappoint?.total_orders}</h4>
                            <h5>Total Orders</h5>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="main-order-wrapper">
                            <h4>{getappoint?.completed_orders}</h4>
                            <h5>Completed Orders</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3 pe-3">
                    {getappoint?.orders?.length > 0 ? (
                      <>
                        {getappoint?.orders?.map((data, gindex) => (
                          <div className="col-lg-6" key={gindex}>
                            <div className="doctor-detail-des border-colorful radius-20 p-4">
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-3 mb-2">
                                  <img
                                    src={imgpharmacy}
                                    className="img-fluid"
                                    alt=""
                                  />
                                  <div>
                                    <h4 className="main-heading-font level-7 dark-color mb-0">
                                      {data?.patient_name}
                                    </h4>
                                    <h5 className="mb-0 level-8 extra-color-9">
                                      Prescription
                                    </h5>
                                  </div>
                                </div>
                                <div className="dropdown main-dropdown">
                                  <a
                                    className="click-dropdown black-complete dropdown-toggle1"
                                    href="#"
                                    role="button"
                                    id="dropdownMenuLink"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <span>
                                      {selectedOptions[data?.order_id] ||
                                        data?.status}
                                      
                                    </span>
                                    <i className="fa-solid fa-chevron-down"></i>
                                  </a>
                                  <ul
                                    className="dropdown-menu black-complete"
                                    aria-labelledby="dropdownMenuLink"
                                  >
                                    <li>
                                      <Link
                                        className="dropdown-item level-8 black-complete"
                                        to=""
                                        onClick={() =>
                                          handleSelect(
                                            "pending",
                                            data?.order_id
                                          )
                                        }
                                      >
                                        Pending
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="dropdown-item level-8 black-complete"
                                        to=""
                                        onClick={() =>
                                          handleSelect(
                                            "in-progress",
                                            data?.order_id
                                          )
                                        }
                                      >
                                        In Progress
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="dropdown-item level-8 black-complete"
                                        to=""
                                        onClick={() =>
                                          handleSelect(
                                            "completed",
                                            data?.order_id
                                          )
                                        }
                                      >
                                        Completed
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              {/* Other content */}

                              <div className="flex-x2 mt-3">
                                <div className="my_prescription">
                                  {data?.prescription?.map((item, oindex) => {
                                    return (
                                      <>
                                        <div className="d-flex align-items-center gap-3 mt-1">
                                          <h4 className="extra-color-16 level-7">
                                            {item?.name}
                                          </h4>
                                          <h4 className="extra-color-16 level-7">
                                            - {item?.qty}
                                          </h4>
                                        </div>
                                      </>
                                    );
                                  })}
                                </div>
                                <div>
                                  <div className="mt-2">
                                    <h4 className="extra-color-16 level-7 mb-0">
                                      Prescribed By:
                                    </h4>
                                    <h4 className="extra-color-16 level-6">
                                      Dr. Dave Patil
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    ) : (
                      <Norecord />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrescriptionOrdersall;
